import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./style.css";
import { Link } from "react-router-dom";

export const BookCoverVorlage = ({ buch }) => {
  // Initial language is set to 'de' by default.
  const [currentLanguage, setCurrentLanguage] = useState('de');

  // Array of available languages
  const languages = ['de', 'en', 'sp', 'fr'];

  // Function to rotate through the languages
  const rotateLanguage = () => {
    const currentLangIndex = languages.indexOf(currentLanguage);
    const nextLangIndex = (currentLangIndex + 1) % languages.length;
    setCurrentLanguage(languages[nextLangIndex]);
  };

  useEffect(() => {
    console.log(buch);
  }, []);
  {/*Legacy Code in here because not all books have new Languages*/}
  return (
    <div className="book-cover-vorlage">
      {/* When this div is clicked, rotate the language */}
      <div className="langChange" onClick={rotateLanguage}></div>
      <Link to={`/readingfreechoice/${buch[`title_${currentLanguage}`] || buch.title}`} key={buch.title}> 
        <img className="buchmockup" alt="Buchmockup" src={buch.imageURL} />
        <div className="white-box">
          <div className="buchname">{buch[`title_${currentLanguage}`] || buch.title}</div>
          {/* Display description based on the current language */}
          <div className="hier-wird-das-buch">{buch[`description_${currentLanguage}`] || buch.description}</div>
        </div>
      </Link>
    </div>
  );
};

BookCoverVorlage.propTypes = {
  buch: PropTypes.object.isRequired,
};